// extracted by mini-css-extract-plugin
module.exports = {"sample_maintenance_left_table_wrapper":"LeftTable_sample_maintenance_left_table_wrapper__OmnXL"};